import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DirectoryDto {
  name: string
  url: string
}

type State = {
  directory: DirectoryDto[]
  history: DirectoryDto[]
}

type Actions = {
  setDirectory: (directory?: DirectoryDto[]) => void
  setHistory: (history?: DirectoryDto[]) => void
  logout: () => void
}

export const useDirectory = create(
  persist<State & Actions>(
    (set) => ({
      directory: [
        {
          name: 'Início',
          url: '/',
        },
      ],
      history: [
        {
          name: 'Início',
          url: '/',
        },
      ],
      setDirectory: (directory?: DirectoryDto[]) => {
        return set(() => ({
          directory,
        }))
      },
      setHistory: (history?: DirectoryDto[]) => {
        return set(() => ({
          history,
        }))
      },
      logout: () => {
        return set(() => ({
          directory: [
            {
              name: 'Início',
              url: '/',
            },
          ],
        }))
      },
    }),
    {
      name: 'directory',
    },
  ),
)
